import { IMetf, EtfMarketSummaryResult, EtfNetValue } from '/@/api/metf/model/index';
import { defineStore } from 'pinia';
import { store } from '/@/store';
import {
  fetchEtfBaseInfoApi,
  fetchEtfMarketSummary,
  fetchEtfNetValue,
  fetchEtfAssetLatestDro,
} from '/@/api/metf';

export const useMetfStore = defineStore('metf', {
  state: () => ({
    metf: {} as Nullable<IMetf>,
    // 底层资产相关信息
    etfAssetSummary: {} as EtfMarketSummaryResult,
    lastNetValue: {} as Nullable<EtfNetValue>,

    etfAssetLatestDro: {},
  }),
  actions: {
    async fetchBaseInfo(productCode: string) {
      this.metf = await fetchEtfBaseInfoApi(productCode);
    },
    async fetchEtfAssetSummary(productCode: string) {
      this.etfAssetSummary = await fetchEtfMarketSummary({ productCode });
    },
    async fetchLastNetValue(productCode: string) {
      this.lastNetValue = await fetchEtfNetValue({ productCode });
    },
    async fetchAssetLatestDro(productCode: string) {
      this.etfAssetLatestDro = await fetchEtfAssetLatestDro(productCode);
    },
  },
  getters: {
    getMetf(state) {
      return state.metf;
    },
  },
});

// Need to be used outside the setup
export function useMetfStoreWithOut() {
  return useMetfStore(store);
}
